import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "./Auth";

import { useLocation } from "react-router-dom";

import { usePrevious } from "lib/hooks";

const PrivateRoute = ({
  component: RouteComponent,
  children,
  render,
  ...rest
}) => {
  const { getCurrentUser } = useContext(AuthContext);

  const currentUser = getCurrentUser();

  let location = useLocation();

  const prevLocation = usePrevious(location);

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        if (!currentUser) {
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: { successUrl: location.pathname, referrer: prevLocation },
              }}
            />
          );
        } else {
          if (!!RouteComponent) {
            return <RouteComponent {...routeProps} />;
          } else if (!!render) {
            return render();
          } else {
            return children;
          }
        }
      }}
    />
  );
};

export default PrivateRoute;
